import React from 'react';
import DiskSpaceStats from './DiskSpaceStats';
import { styled } from '@mui/system';

const Board = styled('div')({
  display: 'flex',
})

export default () => {
  return <Board><DiskSpaceStats/></Board>;
};